import BaseAlert from "../components/Base/BaseAlert"
import BasePagination from "../components/Base/BasePagination"

export default {
    install(Vue) {
        Vue.component(BaseAlert.name, BaseAlert)
        Vue.component(BasePagination.name, BasePagination)
    }
}
